import AddAFieldInput from '../../AddAField/AddAFieldInput/AddAFieldInput';

export function FormTemplateDateField(props) {
  const { fieldValues, validateAllFields } = props;

  return (
    <>
      <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
        <AddAFieldInput
          key={`${fieldValues.id}title`}
          fieldValues={fieldValues}
          validateAllFields={validateAllFields}
          fieldAttributeName="title"
        />
        <AddAFieldInput
          key={`${fieldValues.id}input_guidance`}
          fieldValues={fieldValues}
          validateAllFields={validateAllFields}
          fieldAttributeName="input_guidance"
        />
        <AddAFieldInput
          key={`${fieldValues.id}required`}
          fieldValues={fieldValues}
          validateAllFields={validateAllFields}
          fieldAttributeName="required"
        />
      </div>
      <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
        <AddAFieldInput
          key={`${fieldValues.id}field_type`}
          fieldValues={fieldValues}
          validateAllFields={validateAllFields}
          fieldAttributeName="field_type"
        />
        <AddAFieldInput
          key={`${fieldValues.id}date_restriction`}
          fieldValues={fieldValues}
          validateAllFields={validateAllFields}
          fieldAttributeName="date_restriction"
        />
      </div>
    </>
  );
}

export default FormTemplateDateField;
